import { ROUTE_PATH as STATS_BASE_PATH } from '@/features/statisticsPage/consts';

export const ROUTE_PATH = `${STATS_BASE_PATH}/users`;

export const RESOURCE_NAME = 'usersStatisticsPage';
